'use strict';

angular.module('cvsApp')
  .factory("guestDataService", ['$http', '$q','patientInfoService','getRXHistoryDetailsService','retrieveFormOfPaymentService', function($http,$q,PIS,RXHDS,RFOP) {

    //  Private variables
    var _accountBalanceData = {};
    var _mopData = {};
    var _patientData = {};
    var _rxHistoryData = {};

    var _paymentPending = false;
    var _numRefills = 0;
    var _paymentHistoryError=false;
    var _retrievePatientInformationError=false;
    var _retrievePaymentInformationError=false;

    //  Define the public API
    return {

      get retrievePatientInformationError() {
        return _paymentHistoryError;
      },
      get retrievePaymentInformationError() {
        return _retrievePaymentInformationError;
      },

      //  Current Account Balance
      get currentBalance() {
        return parseFloat(_accountBalanceData.accountBalance);
      },
      //  TODO: Remove this for PROD, only using this
      //  to dynamically configure the prototype version
      set currentBalance(b) { _accountBalanceData.accountBalance = b; },

      //  Whether user has a pending payment
      get paymentPending() {
        return _paymentPending;
      },
      //  TODO: Remove this for PROD, only using this
      //  to dynamically configure the prototyep version
      set paymentPending(p) {
        _paymentPending = p;
      },

      // Primary address on file
      get primaryAddress() {
        return _patientData.patientsAddresses.patientsAddress[0];
      },

      //  Get number of available refills
      get numRefills() {
        return _numRefills;
      },

      //  All Available Payment Methods
      get paymentMethods() {
        return _mopData;
      },

      //  Get the User's prescription history
      get rxHistory() {
        return _rxHistoryData;
      },

      //  Return a MOP data object based on Account ID
      getMopById: function(id) {
        return _.find(_mopData, ['paymentMethodId', id]);
      },

      //  TODO: Need actual creation of unique Account ID
      generateMopId: function() {
        return new Date().getTime();
      },

      addNewMop: function(account) {
        _mopData.push(account);
      },

      //  Initialize the AccountData Service
      //  Hit the following services
      //  - /getPatientInformation
      //  - /getRxHistoryDetails
      //  - /retrieveAccountBalance
      //  - /retrieveFormOfPayment
      init: (function() {
        var d = $q.all([
          PIS.getPatientInformationData(getPatientInfo),
          RXHDS.getRXHistoryDetails(getRXHistorySuccess),
          RFOP.retrieveFormOfPaymentdata(onGetPaymentSuccess)
          //$http.get('data/getPatientInformation.json'),
          //$http.get('data/getRxHistoryDetails.json'),
          //$http.get('data/retrieveAccountBalance.json')
        ]);
        /*d.then(function(ret) {
          _patientData = ret[0].data.response.details.patientProfile;
          _rxHistoryData = ret[1].data.response.details.rxHistory;
          _accountBalanceData = ret[2].data.response.details;
          _mopData = [];

          for (var i = 0; i < _rxHistoryData.rxDetails.length; i++) {
            if (_rxHistoryData.rxDetails[i].readyForRefill.toUpperCase() === "Y") {
              _numRefills++;
            }
          }

        });*/
        function getPatientInfo(data){
          if(data.SERVER_ERROR){
            _retrievePatientInformationError=true;
            return ;
          }
          _patientData = data;
        };
        function getRXHistorySuccess(data) {
       

          if (data.SERVER_ERROR) {
            rPresc.ERROR = data;
            return;
          }
          _rxHistoryData = data.getRXHistoryDetails();
          for (var i = 0; i < _rxHistoryData.length; i++) {
            if (_rxHistoryData[i].readyForRefill.toUpperCase() === "Y") {
              _numRefills++;
            }
          }
        };
        function onGetPaymentSuccess(data){
          if(data.SERVER_ERROR){

            if(typeof utag != 'undefined'){
              utag.view({form_field_error: 'SOP:' + payment.ERROR.ERROR_MSG
              });
            }
            return;
          }
          _mopData = data.getPaymentInfos();
        }
        return d;
      })
    };
  }]);
